<div *ngIf="ctx && ctx.SortOptions" class="dropdown" tooltip="Kies hier uw sorteervolgorde" placement="top" container="body">
  <button type="button" class="btn" [ngClass]="btn" data-bs-toggle="dropdown">
    <i class="fas fa-sort-alpha-down"></i> <span class="ms-2">{{mainService.getActiveSort(ctx.SortOptions)?.Name}}</span>
  </button>
  <span class="dropdown-menu">
    <a *ngFor="let sort of ctx.SortOptions" class="dropdown-item" (click)="mainService.setActiveSort(ctx.SortOptions, sort)">
      <span [ngClass]="{'transparant':!sort.Active}"><i class="fas fa-check"></i> </span>
      {{sort.Description}}</a>
  </span>
</div>